<div class="mt-4">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" disabled>Réassorts</button></li>
  </ol>
</div>

<div class="p-3 mb-3 bg-white rounded shadow-sm" *ngIf="restocks &amp;&amp; restocks.content.length == 0">Aucun réassort</div>

<div class="container-fluid">
  <div class="d-flex p-3 mb-3 bg-white rounded shadow-sm row" *ngFor="let restock of restocks?.content || []">
    <h5 class="col-xl">{{ restock.creationDate | date: 'medium' }}</h5>
    <div class="col-xl">{{ restock.references }} référence(s)</div>
    <div class="col-xl p-2">
      <restock-status [status]="restock.status"></restock-status>
    </div>
    <div class="col-xl-4">
      <div>Ouvert le <strong>{{ restock.creationDate | date: 'medium' }}</strong></div>
      <div *ngIf="restock.completedDate">Complété le <strong>{{ restock.completedDate | date: 'medium' }}</strong></div>
    </div>
    <div class="col-xl">
      <button class="btn btn-sm btn-outline-primary m-2" (click)="openRestock(restock)"><span class="bi bi-file-text"></span></button>
    </div>
  </div>
</div>